<template>
  <el-collapse-item title="Ambulatory" name="12">
    <template slot="title">
      <el-col :span="12" style="padding-left: 0px;">
        Ambulatory Surgery Center
      </el-col>
      <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
        {{ ambulatoryChartsTotal > 0 ? '' + ambulatoryChartsTotal + ' Records' : '' }}
      </el-col>
    </template>
    <el-col class="collapseContentLeft" :span="7">
      <span>HIA will validate:</span>
      <ul class="hiaValidation ambValidations">
        <template v-if="getReviewValidations('AMB').length">
          <li v-for="item in getReviewValidations('AMB')" :key="item.id">{{ item.description }}</li>
        </template>
        <template v-else>
          <li>TBD</li>
        </template>
      </ul>
      <el-button :disabled="!hasAmbulatoryData() || !canClearRecords" plain style="margin: 15px 0px 0px 0px;" @click="clearAmbEmit()"> Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i> </el-button>
    </el-col>
    <el-col class="collapseContentLeft" :span="17">
      <el-form label-position="top">
        <el-row>
          <el-col style="padding-right: 10px;" :span="24">
            <el-button style=" margin: 20px 0px 15px 0px;" icon="el-icon-plus" plain @click="openSpecialtiesModal()">
              Add/Update Specialties
            </el-button>
            <el-table id="ambRecordConfirmTable" ref="ambRecordConfirmTable" class="top-margin" :data="ambulatoryTableRecords">
              <el-table-column label="Specialty" width="180">
                <template slot-scope="scope">
                  <span>{{ specialtyLabel(scope.row.specialtyId) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Other Instructions">
                <template slot-scope="scope">
                  <span class="breakWord" v-html="scope.row.otherInstructions"></span>
                </template>
              </el-table-column>
              <el-table-column label="Number of Records" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.chartCount != null ? scope.row.chartCount : 0 }}</span>
                </template>
              </el-table-column>
              <template slot="empty">
                <p>No Ambulatory specialty rows</p>
              </template>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="padding: 10px 10px 0px 0px;" :span="24">
            <el-form-item label="Please explain if any of these charts have special instructions:">
              <el-input type="textarea" :rows="4" placeholder="Instructions" v-model="ambulatoryRecords.instructions" @change="putAmbulatory()"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <ReviewRequestAmbulatorySpecialtiesModal :specialties="addSpecialties.filter(x => x.specialty !== 'By Coder')" :showSpecialtiesModal="showSpecialtiesModal" @apply="saveAndCloseSpecialtiesModal" @cancel="cancelSpecialtiesModalSave()"> </ReviewRequestAmbulatorySpecialtiesModal>
      </el-form>
    </el-col>
  </el-collapse-item>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ReviewRequestAmbulatorySpecialtiesModal from './ReviewRequestAmbulatorySpecialtiesModal'

export default {
  props: {
    loading: {
      type: Boolean
    },
    addRecords: {
      type: Object
    },
    reviewRequest: {
      type: Object
    },
    isEditRoute: {
      type: Boolean,
      default: false
    },
    canClearRecords: {
      type: Boolean,
      default: true
    },
    remainingRecordsWithoutAmbulatory: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      showSpecialtiesModal: false,
      addSpecialties: [],
      specialtiesBackup: [],
      ambulatoryRecords: {
        type: 'ambulatory',
        title: 'Ambulatory',
        instructions: '',
        chartCount: 0,
        records: []
      },
      validations: [{ id: 100, patientType: 'AMB', description: 'ASC Payment Indicators' }, { id: 101, patientType: 'AMB', description: 'All ICD-10 CM Codes' }, { id: 102, patientType: 'AMB', description: 'CPT Codes assigned' }, { id: 103, patientType: 'AMB', description: 'Appropriate Coder Query' }]
    }
  },
  name: 'ReviewRequestAmbulatoryRecordDetails',
  methods: {
    ...mapActions('requests/', ['GET_AMBULATORY_SPECIALTIES_LOOKUP']),
    sumRecordsChartCount(records) {
      if (!records || !records.length) {
        return 0
      }
      return records.reduce((a, r) => a + (Number(r.chartCount) || 0), 0)
    },
    specialtyLabel(specialtyId) {
      let s = this.ambulatorySpecialtiesLookup.find(x => x.id === specialtyId)
      return s ? s.specialty : ''
    },
    clearAmbEmit() {
      if (!this.canClearRecords) {
        this.$message({
          type: 'error',
          message: 'A review request must have at least one record selected.',
          duration: 5000
        })
        return
      }
      this.$emit('clearAmbulatory')
    },
    clearAmb() {
      this.setAddRowSpecialties()
      this.specialtiesBackup = JSON.parse(JSON.stringify(this.addSpecialties))
      this.ambulatoryRecords.chartCount = 0
      this.ambulatoryRecords.instructions = ''
      this.ambulatoryRecords.records = []
    },
    putAmbulatory() {
      const recs = this.ambulatoryRecords.records || []
      const sum = this.sumRecordsChartCount(recs)
      this.ambulatoryRecords.chartCount = sum
      this.$emit('addAmbulatoryRecords', { ambulatoryRecords: { ...this.ambulatoryRecords, chartCount: sum, records: recs } })
    },
    getReviewValidations(type) {
      return this.validations
      // return this.reviewValidations.filter(x => x.patientType === type)
    },
    openSpecialtiesModal() {
      this.specialtiesBackup = JSON.parse(JSON.stringify(this.addSpecialties))
      this.showSpecialtiesModal = true
    },
    cancelSpecialtiesModalSave() {
      this.addSpecialties = this.specialtiesBackup
      this.showSpecialtiesModal = false
    },
    setAddRowSpecialties() {
      this.addSpecialties = []
      this.addSpecialties = this.ambulatorySpecialtiesLookup.map(x => ({
        selected: false,
        specialty: x.specialty,
        specialtyId: x.id,
        chartCount: 0,
        id: 0,
        otherInstructions: null
      }))
    },
    saveAndCloseSpecialtiesModal(payload) {
      this.showSpecialtiesModal = false
      this.saveSpecialties(payload)
    },
    saveSpecialties(payload) {
      const newAmbCount = this.sumRecordsChartCount(payload.map(row => ({
        chartCount: row.chartCount != null ? row.chartCount : 0
      })))
      if (this.isEditRoute && this.remainingRecordsWithoutAmbulatory + newAmbCount <= 0) {
        this.$message({
          type: 'error',
          message: 'A review request must have at least one record selected.',
          duration: 5000
        })
        return
      }
      this.ambulatoryRecords.records = payload.map(row => ({
        id: row.id || 0,
        specialtyId: row.specialtyId,
        chartCount: row.chartCount != null ? row.chartCount : 0,
        otherInstructions: row.otherInstructions
      }))
      this.putAmbulatory()
    },
    hasAmbulatoryData() {
      const recs = (this.reviewRequest.ambulatoryRecords && this.reviewRequest.ambulatoryRecords.records) || []
      return recs.some(r => (Number(r.chartCount) || 0) > 0) || this.sumRecordsChartCount(this.ambulatoryRecords.records) > 0 || !!(this.reviewRequest.ambulatoryRecords && this.reviewRequest.ambulatoryRecords.instructions) || !!this.ambulatoryRecords.instructions
    },
    recordCheck() {
      let ar = this.reviewRequest.ambulatoryRecords
      if (!ar) {
        return
      }
      this.ambulatoryRecords.instructions = ar.instructions || ''
      const recs = ar.records || []
      this.ambulatoryRecords.records = [...recs]
      this.ambulatoryRecords.chartCount = ar.chartCount != null ? ar.chartCount : this.sumRecordsChartCount(recs)
      if (recs.length > 0) {
        this.setAddRowSpecialties()
        this.specialtiesCheck()
      }
    },
    specialtiesCheck() {
      let rows = this.ambulatoryRecords.records.length ? this.ambulatoryRecords.records : (this.reviewRequest.ambulatoryRecords && this.reviewRequest.ambulatoryRecords.records) || []
      for (let i = 0; i < rows.length; i++) {
        let index = this.addSpecialties.findIndex(x => x.specialtyId === rows[i].specialtyId)
        if (index < 0) {
          continue
        }
        let item = Object.assign({}, rows[i], {
          selected: true,
          specialty: this.addSpecialties[index].specialty
        })
        this.addSpecialties.splice(index, 1, item)
      }
    }
  },

  computed: {
    ...mapState('requests/reviews', ['reviewValidations']),
    ...mapState('requests/', ['ambulatorySpecialtiesLookup']),
    ambulatoryTableRecords() {
      if (!this.reviewRequest || !this.reviewRequest.ambulatoryRecords) {
        return []
      }
      return this.reviewRequest.ambulatoryRecords.records || []
    },
    ambulatoryChartsTotal() {
      const ar = this.reviewRequest && this.reviewRequest.ambulatoryRecords
      if (ar && ar.records && ar.records.length) {
        return this.sumRecordsChartCount(ar.records)
      }
      return this.sumRecordsChartCount(this.ambulatoryRecords.records)
    }
  },

  components: {
    ReviewRequestAmbulatorySpecialtiesModal
  },

  async created() {
    await this.GET_AMBULATORY_SPECIALTIES_LOOKUP()
    this.setAddRowSpecialties()
    this.recordCheck()
  }
}
</script>

<style scoped>
.ambValidations {
  height: 200px;
  overflow-y: scroll;
}

.hiaValidation {
  margin: 0px 0px 0px 0px;
  padding: 2px 5px 2px 5px;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 10px;
  background: rgba(238, 238, 238, 0.5);
}

.hiaValidation li {
  list-style-type: none;
}

.breakWord {
  word-break: break-word;
}

.top-margin {
  margin-top: 10px;
}
.collapseContentLeft {
  padding: 5px 0px 8px 10px !important;
}
</style>
